import './scheduling-project-configurations/scheduling-project-configurations.component';
import './scheduling-project-configurations/scheduling-project-configurations.scss';

import './scheduling-project-templates-multi-select-list/scheduling-project-templates-multi-select-list.component';
import './scheduling-project-templates-multi-select-list/scheduling-project-templates-multi-select-list.scss';

import './scheduling-project-templates-display-list/scheduling-project-templates-display-list.component';

import './scheduling-project-visit-plans-view/scheduling-project-visit-plans-view.component';
import './scheduling-project-visit-plans-view/scheduling-project-visit-plans-view.scss';

import './scheduling-project-visit-plan-templates-view/scheduling-project-visit-plan-templates-view.component';
import './scheduling-project-visit-plan-templates-view/scheduling-project-visit-plan-templates-view.scss';

import './scheduling-project-visit-plan-calendar-view/scheduling-project-visit-plan-calendar-view.component';
import './scheduling-project-visit-plan-calendar-view/scheduling-project-visit-plan-calendar-view.scss';

import './scheduling-project-visit-plan-table-view/scheduling-project-visit-plan-table-view.component';
import './scheduling-project-visit-plan-table-view/scheduling-project-visit-plan-table-view.scss';

import './scheduling-project-reports-view/scheduling-project-reports-view.component';
import './scheduling-project-reports-view/scheduling-project-reports-view.scss';

import './scheduling-project-calendar-schedule/scheduling-project-calendar-schedule.component';
import './scheduling-project-calendar-schedule/scheduling-project-calendar-schedule.scss';

import './visit-configurations-view/visit-configurations-view.component';
import './visit-configurations-view/visit-configurations-view.scss';

import './visit-plan-view/visit-plan-view.component';
import './visit-plan-view/visit-plan-view.scss';

import './visit-schedule-timeline/visit-schedule-timeline.component';
import './visit-schedule-timeline/visit-schedule-timeline.scss';

import './call-sub-tasks-form/call-sub-tasks-form.component';
import './call-sub-tasks-form/call-sub-tasks-form.scss';

import './visit-plan-routes-map/visit-plan-routes-map.component';
import './visit-plan-routes-map/visit-plan-routes-map.scss';

import './visit-plan-dispatch-view/visit-plan-dispatch-view.component';
import './visit-plan-dispatch-view/visit-plan-dispatch-view.scss';

import './visit-plan-dispatch-timeline/visit-plan-dispatch-timeline.component';
import './visit-plan-dispatch-timeline/visit-plan-dispatch-timeline.scss';

import './visit-plan-routes-map/visit-plan-routes-map.component';
import './visit-plan-routes-map/visit-plan-routes-map.scss';

import './visit-plan-routes-timeline/visit-plan-routes-timeline.component';
import './visit-plan-routes-timeline/visit-plan-routes-timeline.scss';

import './optimize-visit-schedule-dialog-form/optimize-visit-schedule-dialog-form.component';
import './optimize-visit-schedule-dialog-form/optimize-visit-schedule-dialog-form.scss';

import './visit-plan-account-info-component/visit-plan-account-info-component.component';
import './visit-plan-account-info-component/visit-plan-account-info-component.scss';

import './visit-configuration-upload-recap-table/visit-configuration-upload-recap-table.component';
import './visit-configuration-upload-recap-table/visit-configuration-upload-recap-table.scss';
